import React, {useState} from 'react';
import { InputAdornment } from '@material-ui/core';
import DialpadIcon from '@material-ui/icons/Dialpad';
import { GLOBAL_DIALER_TYPES } from '../../../helpers/CoreConstant';
import BasicInputForSearch from '../../custom/BasicInputForSearch';
import { searchIcon } from '../../GlobalAddDealModalV3/AddDealIcons';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import Utils from "../../../helpers/Utils";
import {useDispatch, useSelector} from "react-redux";
import CloseIcon from "@material-ui/icons/Close";
import {setCallEnvironment} from "../../../reducers/globalDialerV2/globalDialerSlice";
import BootstrapTooltip from "../../common/BootstrapTooltip";

const DialerHeader = ({ dialerType: dialerTypeProp, onSearch, onDialerTypeChange}) => {
    const dispatch = useDispatch();
    const {callEnvironment} = useSelector((state)=>(state.globalDialerV2));
    const [search, setSearch] = useState("");
    const [dialerType, setDialerType] = useState(dialerTypeProp ?? GLOBAL_DIALER_TYPES.DEFAULT);

    const handleSearch = (e) => {
        if (dialerType === GLOBAL_DIALER_TYPES.KEYPAD){
            if (e.target.value === ""){
                onDialerTypeChange(GLOBAL_DIALER_TYPES.KEYPAD);
            }else {
                onDialerTypeChange(GLOBAL_DIALER_TYPES.DEFAULT);
            }
        }else if (dialerType === GLOBAL_DIALER_TYPES.TEAM_TRANSFER){
            if (e.target.value === ""){
                onDialerTypeChange(GLOBAL_DIALER_TYPES.TEAM_TRANSFER);
            }else {
                onDialerTypeChange(GLOBAL_DIALER_TYPES.DEFAULT);
            }
        }

        setSearch(e.target.value);
        onSearch(e.target.value);
    };

    const handleClose = () => {
        dispatch(setCallEnvironment({
            isTransferring: false
        }));
    };

    const handleDialerTypeChange = (type) => {
        if (dialerType === GLOBAL_DIALER_TYPES.KEYPAD) {
            if (dialerType === GLOBAL_DIALER_TYPES.KEYPAD && search){
                setDialerType(GLOBAL_DIALER_TYPES.KEYPAD);
                onDialerTypeChange(GLOBAL_DIALER_TYPES.KEYPAD);
                return;
            }

            if (!callEnvironment.isTransferring){
                setDialerType(GLOBAL_DIALER_TYPES.DEFAULT);
                onDialerTypeChange(GLOBAL_DIALER_TYPES.DEFAULT);
                return;
            }
        }

        if (dialerType === GLOBAL_DIALER_TYPES.TEAM_TRANSFER){
            if (dialerType === GLOBAL_DIALER_TYPES.TEAM_TRANSFER && search){
                setDialerType(GLOBAL_DIALER_TYPES.TEAM_TRANSFER);
                onDialerTypeChange(GLOBAL_DIALER_TYPES.TEAM_TRANSFER);
                return;
            }

            if (type !== GLOBAL_DIALER_TYPES.KEYPAD){
                setDialerType(GLOBAL_DIALER_TYPES.DEFAULT);
                onDialerTypeChange(GLOBAL_DIALER_TYPES.DEFAULT);
                return;
            }
        }

        setDialerType(type);
        onDialerTypeChange(type);
    };

    return (
        <div className='globalDialerHeader' style={{ marginTop: callEnvironment.isTransferring  ? '20px' : '0px' }}>
            <BasicInputForSearch
                value={Utils.formatNumber(search) || ""}
                placeholder={'Search for a contact or enter a number' }
                endAdornment={
                    <InputAdornment position='start' style={{ paddingLeft: "18px" }}>
                        <span>{searchIcon({ width: 20, height: 20 })}</span>
                    </InputAdornment>
                }
                className='searchInput'
                onChange={handleSearch}
            />

            <BootstrapTooltip arrow placement="bottom" title="Dialpad">
                <div
                    className='headerActionButton'
                    onClick={() => {
                        handleDialerTypeChange(GLOBAL_DIALER_TYPES.KEYPAD);
                        setSearch('');
                    }}
                    style={{
                        outline: dialerType === GLOBAL_DIALER_TYPES.KEYPAD ?
                            '#33f28b solid 2px' : 'transparent solid 2px',
                        padding: dialerType === GLOBAL_DIALER_TYPES.KEYPAD ?
                            '7px' : '7px'
                    }}
                >
                    <DialpadIcon />
                </div>
            </BootstrapTooltip>

            {
                callEnvironment.isTransferring && (
                    <>  
                        <div style={{ position: 'absolute', top: 8, left: 16, fontSize: 16, color: '#ffffff' }}>Call Transfer</div>
                        <BootstrapTooltip arrow placement="bottom" title={dialerType === GLOBAL_DIALER_TYPES.TEAM_TRANSFER ? "Contacts" : "Team"}>
                            <div
                                className='headerActionButton'
                                onClick={() => handleDialerTypeChange(GLOBAL_DIALER_TYPES.TEAM_TRANSFER)}
                                style={{ outline: dialerType === GLOBAL_DIALER_TYPES.TEAM_TRANSFER ? '#33f28b solid 2px': 'none' }}
                            >
                                <AccountCircleIcon />
                            </div>
                        </BootstrapTooltip>

                        <BootstrapTooltip arrow placement="bottom" title="Cancel Transfer">
                            <span style={{ position: 'absolute', top: 8, right: 16, fontSize: 16, color: '#fff', cursor: 'pointer' }} onClick={handleClose}>
                                <CloseIcon style={{ fontSize: '16px', color: '#fff' }} />
                            </span>
                        </BootstrapTooltip>
                    </>
                )
            }
        </div>
    );
};

export default DialerHeader;